import React, { useState, useRef} from "react";
import { FaBars } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const Location = useLocation(); // Get the current route

  // Close menu when hovering away (only in mobile view)
 

   // Scroll to top when navigating to a new page
   const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsOpen(false); // Close menu on mobile
  };


  return (
    <nav ref={menuRef}>
      {/* Left-side Logo */}
      <img src="/Image/logo.png" alt="Website Logo" className="navbar-logo" />

      {/* Menu Icon for Mobile */}
      <div 
        className="menu-icon" 
        onClick={(e) => {
          e.stopPropagation(); // Prevent closing when clicking the icon
          setIsOpen(!isOpen);
        }}
      >
        <FaBars />
      </div>

      {/* Navigation Links (Right Side) */}
      <ul className={`nav-links ${isOpen ? "show" : ""}`}>
        <li className="nav-item">
          <Link to="/" className="nav-link" onClick={handleNavClick}>Home</Link>
        </li>
        <li className="nav-item">
          <Link to="/about" className="nav-link" onClick={handleNavClick}>About</Link>
        </li>
        <li className="nav-item">
          <Link to="/services" className="nav-link" onClick={handleNavClick}>Services</Link>
        </li>
        <li className="nav-item">
          <Link to="/contact" className="nav-link" onClick={handleNavClick}>Contact</Link>
        </li>
        <li className="nav-item">
          <Link to="/career" className="nav-link" onClick={handleNavClick}>Career</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
